import { useMediaQuery, useTheme } from "@mui/material";
import { ListItemActionArea, ListItemArea, ListItemBase, ListItemLayout } from "./styled-components";

/**
 * This component is part of the VR app V2 redesign
 */

interface IBybListItem {
  children: React.ReactNode;
  columns?: number;
  onClick?: () => void;
}

const BybListItem = ({ children, columns = 6, onClick }: IBybListItem) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const ListItemElement = onClick ? ListItemActionArea : ListItemArea;

  const listItemStyles = isMobile ? { padding: 0, borderRadius: 0 } : { padding: theme.spacing(1), borderRadius: theme.spacing(2) };

  return (
    <ListItemBase sx={listItemStyles}>
      <ListItemElement
        onClick={onClick}
        isMobile={isMobile}
        sx={isMobile ? undefined : { cornerShape: "squircle", borderRadius: "32px", overflow: "hidden" }}
      >
        <ListItemLayout columns={columns}>{children}</ListItemLayout>
      </ListItemElement>
    </ListItemBase>
  );
};

export default BybListItem;
